import TemplateView from '../../../../TemplateView'
import messageResource from "../../../../messageResource";

export const Type = {
    MANUAL: 'manual',
    CSV_IMPORT: 'csvImport',
}

export default class BulkInvitationsItem extends TemplateView {
    constructor({
        type = '',
        additionalClass = '',
        onClick = (type) => {},
    }) {
        super(null)

        this.type = type
        this.additionalClass = additionalClass
        this.onClick = onClick

        this.text = ''
        switch (type) {
            case Type.MANUAL:
                this.text = messageResource.getMessage('userlist.manual_invitation')
                break
            case Type.CSV_IMPORT:
                this.text = messageResource.getMessage('userlist.csv_import')
                break
        }
    }

    afterRender() {
        this.$el.on('click', () => {this.onClick(this.type)})
    }

    templateHtml() {
        return '<div class="userList_invitationButtonsDropdown_item <%=type%> <%=additionalClass%>">' +
               '  <%-text%>' +
               '</div>'
    }
}




// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/managementButtons/BulkInvitationsItem.js